<template>
    <v-container align="center">
        <v-row>
            <v-col cols=12>
                <v-container align="center">
                <p>Si no encuentra el mail de confirmacion en su bandeja de entrada, ingrese su correo y le enviaremos un nuevo mail de confirmacion</p>
                </v-container>
                <v-card align="center" flat>
                    <form @submit.prevent="validateLoginForm">
                        
                        
                            <v-col cols="12" md="6">
                                <v-text-field type="text" name="federation_acct"
                                    label="E-Mail"
                                    v-model="authinfo.federation_acct"
                                    placeholder="MAIL"
                                    :error-messages="$v.authinfo.federation_acct.$error ? 'Este campo es requerido' : ''"
                                />
                            </v-col>
                        
                        
                            <v-col cols="12" md="6">
                                <v-btn
                                    @click.prevent="send_mail">Reenviar mail</v-btn>
                            </v-col>
                        
                    </form>
                    <v-dialog
                        v-model="dialog"
                        persistent
                        width="300"
                    >
                        <v-card
                        color="primary"
                        dark
                        >
                        <v-card-text>
                            Por favor espere
                            <v-progress-linear
                            indeterminate
                            color="white"
                            class="mb-0"
                            ></v-progress-linear>
                        </v-card-text>
                        </v-card>
                    </v-dialog>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
import { resendEmail } from '@/services/monolito';

export default {
    name: 'resend',
    mixins: [validationMixin],
    data() {
        return {
            authinfo: {
                federation_acct: "",
            },
            stderr: [],
            dialog : false,
        }
    },
    validations() {
        return {
            authinfo: {
                federation_acct: { required, minLength: minLength(9), maxLength: maxLength(37) }
            }
        }
    },
    computed: {
        // Check that the server field is not empty
        IsEmpty () {
        const empty = this.authinfo.federation_acct.length == 0
        return empty ? true : false
        }
    },
    watch: {
        dialog (val) {
        if (!val) return
        }
    },
    methods: {
        async validateLoginForm() {
            const result = await this.$v.$validate()
            if (!result) {
                return
            }
            await this.send_mail()
        },
        set_dialog(state){
            this.dialog = state
        },
        set_sendmail () {
                // redirect to the "Workplace" component
                this.$router.replace({ name: "login" });
            },

        /* Connects to the Thalamus server */
        async send_mail () {
            this.dialog = true
            try {
                await resendEmail(this.authinfo.federation_acct);
                await this.$alert({ title: 'Correo reenviado', message: 'Se ha reenviado un mail para que pueda confirmar su cuenta. Por favor revise su bandeja de entrada.', color: 'success' })
                this.set_sendmail();
            } catch (error) {
                if (error.response && error.response.status === 423) {
                    await this.$alert({ title: 'No encontrado', message: 'Este mail no se encuentra en nuestra base de datos.', color: 'error' })
                } else {
                    await this.$alert({ title: 'No se pudo reenviar', message: 'No se ha podido reenviar el mail. Por favor contáctese con nosotros.', color: 'error' })
                }
            }
            this.set_dialog(false);
        },
    }
}
</script>